var map = {
	"./celebrate": 10360,
	"./celebrate.json": 10360,
	"./celebrate.svg": 15071,
	"./heart": 10361,
	"./heart.json": 10361,
	"./heart.svg": 15072,
	"./laugh": 10362,
	"./laugh.json": 10362,
	"./laugh.svg": 15073,
	"./like": 10363,
	"./like.json": 10363,
	"./like.svg": 15074,
	"./sad": 10364,
	"./sad.json": 10364,
	"./sad.svg": 15075,
	"./surprised": 10365,
	"./surprised.json": 10365,
	"./surprised.svg": 15076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15070;